// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file user/v1/user.proto (package user.v1, syntax proto3)
/* eslint-disable */

import { UserService } from "./user_pb";

/**
 * Opens a session from an ID token issued by the identity broker after sign-in.
 *
 * @generated from rpc user.v1.UserService.Login
 */
export const login = UserService.method.login;

/**
 * Returns the user behind the current session.
 *
 * @generated from rpc user.v1.UserService.GetMe
 */
export const getMe = UserService.method.getMe;

/**
 * Terminates the current user session and invalidates the token.
 *
 * @generated from rpc user.v1.UserService.Logout
 */
export const logout = UserService.method.logout;
